<template>
  <div id="app">
    <ValidateDomain v-if="!isValidDomain" />
    <router-view/>
    <SessionExpiryModal />
  </div>
</template>


<script>
import ValidateDomain from "@/components/config_components/ValidateDomain/ValidateDomain.vue";
import SessionExpiryModal from "@/components/config_components/SessionExpiryModal/SessionExpiryModal.vue";

export default {
  props: {
    isValidDomain: {
      type: Boolean,
      required: true,
    },
  },
  components: { SessionExpiryModal, ValidateDomain },
  data() {
    return {
      hostname: window.location.hostname,
    };
  }
};
</script>
